import { render, staticRenderFns } from "./ViewContentSms.vue?vue&type=template&id=55dc8e9a&scoped=true"
import script from "./ViewContentSms.vue?vue&type=script&lang=js"
export * from "./ViewContentSms.vue?vue&type=script&lang=js"
import style0 from "./ViewContentSms.vue?vue&type=style&index=0&id=55dc8e9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc8e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55dc8e9a')) {
      api.createRecord('55dc8e9a', component.options)
    } else {
      api.reload('55dc8e9a', component.options)
    }
    module.hot.accept("./ViewContentSms.vue?vue&type=template&id=55dc8e9a&scoped=true", function () {
      api.rerender('55dc8e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifihistory/ViewContentSms.vue"
export default component.exports